module.exports = __webpack_public_path__ + "img/config-account-icon.6dfed696.svg";